import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useModuleAccess from 'hooks/useModuleAccess';

import { GTMEventLogger } from 'utils/analytics';

import { MenuConfigWithModule } from 'types/route';

import { GTMEvents } from 'constants/enums';

import styles from './HorizontalMenu.module.scss';

interface HorizontalMenuProps {
  items: MenuConfigWithModule[];
}

const HorizontalMenu: FC<HorizontalMenuProps> = ({ items }) => {
  const { t } = useTranslation();
  const hasModuleAccess = useModuleAccess();

  const menuItems = items.filter(
    ({ path, module }) =>
      path === '/' || Boolean(module && hasModuleAccess(module))
  );

  if (!menuItems.length) {
    return null;
  }

  const handleClick = (event?: GTMEvents) => {
    if (event) {
      GTMEventLogger(event);
    }
  };

  return (
    <div className={styles.container}>
      {menuItems.map((item) => (
        <Link
          to={item.path || '/'}
          className={styles.itemLabel}
          key={item.key}
          onClick={() => handleClick(item.event)}
        >
          {t(item.label)}
        </Link>
      ))}
    </div>
  );
};

export default HorizontalMenu;
